import { xor } from "lodash";
import { SocketArgs } from "@shared/services/socket/types";
import { SocketTopics } from "@shared/types";

export const checkPricesArgsChanged = (
  previousArgs?: SocketArgs<SocketTopics.PRICES | SocketTopics.GRAPHS_DATA>,
  args?: SocketArgs<SocketTopics.PRICES | SocketTopics.GRAPHS_DATA>
) => {
  return (
    previousArgs?.symbol !== args?.symbol ||
    previousArgs?.exchange !== args?.exchange ||
    previousArgs?.isAsset !== args?.isAsset
  );
};

export const checkPnlArgsChanged = (
  previousArgs?: SocketArgs<SocketTopics.PNL>,
  args?: SocketArgs<SocketTopics.PNL>
) => {
  const difference = xor(previousArgs?.tradeIds, args?.tradeIds);
  return !!difference.length;
};

export const checkInitialDataArgsChanged = (
  previousArgs?: SocketArgs<SocketTopics.AGG_TRADES | SocketTopics.AGG_BOTS>,
  args?: SocketArgs<SocketTopics.AGG_TRADES | SocketTopics.AGG_BOTS>
) => {
  return (
    previousArgs?.fetch_initial_data !== args?.fetch_initial_data ||
    previousArgs?.as_dict !== args?.as_dict
  );
};
